"use client";

import { twMerge } from "tailwind-merge";

import styles from "./dashboard.module.scss";

export const ClientMyLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={twMerge(
        "group relative flex h-dvh flex-col overflow-y-auto bg-zinc-100 scrollbar-hide",
        styles.dashboard
      )}
    >
      {children}
    </div>
  );
};
